import * as React from "react";
import Header from "./component";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getUserContext } from "../../../User/selectors";
import { UserContext } from "../../google_analytics";
import { currentMerchantName } from "../../../Analytics/selectors";

export interface HeaderProps {
  permissions: any;
  merchantName: string;
  gaUserContext: UserContext;
}

function mapStateToProps(state: any, props: any): HeaderProps {
  return {
    permissions: state.user.permissions,
    merchantName: currentMerchantName(state, props),
    gaUserContext: getUserContext(state, props)
  };
}

export default withRouter(connect(mapStateToProps)(Header));



// WEBPACK FOOTER //
// ./client/modules/common/components/Header/container.ts